import CheckRounded from "../../assets/icons/check-rounded";

export default function SignInConfirm({ context }) {
  const handleClose = async () => {
    document.querySelector("#close-modal-button").click();
    context.navigateUrl("/login");
    document.querySelector(".main-panel").classList.remove("remove-main-panel");
  };

  return (
    <>
      <div className="w-75 text-center mx-auto">
        <div className="d-flex align-items-center justify-content-center">
          <CheckRounded
            size={80}
            color="#9fb833"
            className="d-inline-block mx-auto"
          />
        </div>
        <strong className="d-block mt-4">Operazione effettuata!</strong>
        <span className="mt-3 mb-4 d-block">
          Registrazione completata con successo.
        </span>
      </div>
      <button
        className="q8-blue-button p-3 w-100"
        onClick={() => handleClose()}
      >
        CHIUDI
      </button>
    </>
  );
}
